import { ItemList } from 'models/InputLayoutItem';

export const FinancialList: ItemList[] = [
	{
		value: 'Forum',
		label: 'Forum',
	},
	{
		value: 'Santander Consummer',
		label: 'Santander Consummer',
	},
	{
		value: 'Tanner',
		label: 'Tanner',
	},
	{
		value: 'Autofin',
		label: 'Autofin',
	},
	{
		value: 'Masfin (Nissan)',
		label: 'Masfin (Nissan)',
	},
	{
		value: 'Gmac',
		label: 'Gmac',
	},
	{
		value: 'Global',
		label: 'Global',
	},
	{
		value: 'Nuevo Capital',
		label: 'Nuevo Capital',
	},
	{
		value: 'Mundo Crédito',
		label: 'Mundo Crédito',
	},
	{
		value: 'Eurocapital',
		label: 'Eurocapital',
	},
	{
		value: 'MAF (Mitsui Auto Financial)',
		label: 'MAF (Mitsui Auto Financial)',
	},
	{
		value: 'Banco Falabella',
		label: 'Banco Falabella',
	},
	{
		value: 'Banco Scotiabank',
		label: 'Banco Scotiabank',
	},
	{
		value: 'Astra Abcdin',
		label: 'Astra Abcdin',
	},
	{
		value: 'Afa (Auto Facil)',
		label: 'Afa (Auto Facil)',
	},
	{
		value: 'Marubeni Credit',
		label: 'Marubeni Credit',
	},
	{
		value: 'other',
		label: 'Otras financieras',
	},
];
